export default __webpack_public_path__ + "static/media/CV-Corinne-Pradier-eng.616c9c48.pdf";